<template>
  <div class="section basicInfoForm" style="height: auto">
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item :label="$t('baseInfo.partner.cmpIdx')" class="margin-Right90">
          <el-input v-model="form.cmpIdx" no="cmpIdx" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.partner.chineseName')" :label-width="isZh ? '105px' : '120px'" :required="true">
          <div style="display: flex;">
            <el-input v-model="form.chineseName" no="chineseName" :disabled="!!form.globalAccountUuid || oujianEditLimit" style="flex-grow: 1" :filter-chars="false" @change="checkChineseName" />
            <el-tooltip effect="light" :content="$t('Partners.industrialAndCommercialInformationQuery')" placement="right-end">
              <a :href="tianYanChaUrl" target="_blank" :style="form.chineseName?'':'pointer-events: none;'">
                <img v-if="showTianYanCha" src="/static/eyeInTheSky.png" style="width: 20px;height: 20px;">
              </a>
            </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item :label="$t('baseInfo.partner.shortName')" class="margin-Right90" :required="true">
          <el-input v-model="form.shortName" no="shortName" :disabled="!!form.globalAccountUuid || oujianEditLimit" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.partner.englishName')" :label-width="isZh ? '105px' : '120px'" :required="true">
          <el-input v-model="form.englishName" no="englishName" :disabled="!!form.globalAccountUuid" :filter-chars="false" @change="checkEnglishName" />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly || oujianEditLimit" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item :label="$t('baseInfo.partner.cnShortName')" class="margin-Right90">
          <div style="display: flex">
            <el-input v-model="form.cnShortName" no="cnShortName" :disabled="!!form.globalAccountUuid || yuhaiApiIsEdit" @change="checkCnShortName" />
            <el-checkbox
              v-model="form.active"
              no="active"
              :disabled="!activeEnabled || yuhaiApiIsEdit"
              style="width: 80px;margin-left: 5px"
              @change="onActiveChange"
            >{{ $t('Partners.activity') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label="$t('Partners.inactiveReason')" style="display: block;margin-top: 5px;">
          <el-input v-model="form.inactiveReason" no="inactiveReason" :disabled="form.active" />
        </el-form-item>
        <el-form-item v-if="hbBranchIdVisible" :label="$t('baseInfo.partner.branchId')" :label-width="isZh ? '105px' : '120px'">
          <cargo-owned-branch-select
            v-model="form.branchId"
            no="branchId"
            :disabled="oujianEditLimit"
            :select-type="selectTypeNames.basic_data_Office_All"
            :refresh-id="refreshId"
            style="width: 400px;"
            @change="changeCustomerDept"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left">
        <el-form-item v-if="!isSalesForSzfs" :label="$t('Partners.crossTenantAuthorize')" :label-width="isZh ? '105px' : '160px'">
          <el-checkbox v-model="useCrossTenant" no="useCrossTenant" @change="onCrossTenantChange">{{ $t('Message.Agree') }}</el-checkbox>
          <el-link
            :disabled="readonly"
            type="primary"
            :style="'margin-left: 10px;font-size: 12px;line-height: 12px;width:'+(isZh ? '98px' : '185.23px')"
            @click="agreementDialog.visible=true"
          >{{ $t('Partners.crossTenantAuthorizeAgreement') }}</el-link>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ApplicationBranch1')" :style="!isSalesForSzfs ? {marginLeft: isZh?'238px':'90px'} : ''" :label-width="$selectByLang('105px', '120px')">
          <cargo-owned-branch-select
            :value="toNumArray(form.multipleBranchId)"
            no="multipleBranchId"
            :select-type="selectTypeNames.basic_data_Office_All"
            :static-options="branchCompanyHierarchy ? currentOfficeList : null"
            :refresh-id="multipleRefreshId"
            :multiple="true"
            style="width: 400px;"
            @input="val=>{form.multipleBranchId=toTxt(val)}"
          />
          <el-button size="mini" type="primary" style="margin-left: 5px;" @click="showBranchSelectDialog">...</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left">
        <el-form-item :label="$t('Partners.theOtherPlatformID')" class="margin-Right90">
          <div style="display: flex">
            <cargo-advance-select
              no="relateTenantId"
              :disabled="!useCrossTenant||!!form.globalAccountUuid"
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              :show-custom-label-in-option="true"
              :custom-label="companyLabel"
              :callback-params="{key:'relateTenantId'}"
              callback-method-type="value"
              :default-value="String(form.relateTenantId||'')"
              :static-options="tenants"
              style="width: 295px;"
              @parentCallBack="tenantIdChangeHandler"
            />
            <cargo-advance-select
              no="relateTenantOfficeId"
              :disabled="!useCrossTenant||!form.relateTenantId||!!form.globalAccountUuid"
              :select-type="selectTypeNames.static_data_Office"
              :method-params="{tenantId:form.relateTenantId}"
              filterable
              :clearable="false"
              :callback-params="{key:'relateTenantOfficeId'}"
              callback-method-type="value"
              :fields="['code']"
              tag-name="code"
              tag-value="officeId"
              :default-value="form.relateTenantOfficeId||''"
              :static-options="tenantOfficeList"
              style="width: 100px;margin-left: 5px;"
              @parentCallBack="selectCargoItem"
            />
            <span v-show="isNewDelegation&&form.linkedBranchId" style="margin-left: 10px;">{{ $t('Partners.relatedBranch') }}：{{ form.linkedBranchCode }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('Partners.isParentCompany')" :label-width="$selectByLang('105px', '160px','105px')">
          <el-checkbox v-model="form.parentCompany" no="parentCompany" @change="parentCompanyChange" />
        </el-form-item>
        <el-form-item v-if="extendedInterestRate" :label="$t('Partners.interestFreeCompany')" style="margin-left: 30px;" :label-width="isZh ? '100px' : '160px'">
          <el-checkbox v-model="form.interestFree" no="interestFree" />
        </el-form-item>
        <el-form-item :label="$t('Partners.isFba')" style="margin-left: 30px;">
          <el-checkbox v-model="form.fba" no="fba" :disabled="!form.customer" />
        </el-form-item>
        <!--是否内部往来公司-->
        <el-form-item :label="$t('Partners.isInternalCorrespondent')" style="margin-left: 30px;" label-width="110px">
          <el-checkbox v-model="form.internalCorrespondent" no="internalCorrespondent" />
        </el-form-item>
        <el-form-item v-if="showUnifiedSign" :label="$t('Partners.UnifiedSign')" style="margin-left: 30px;">
          <el-checkbox v-model="form.unifiedSign" no="unifiedSign" />
        </el-form-item>
        <!--风险客商-->
        <el-form-item v-if="showIfRisk" :label="$t('Partners.IfRisk')" style="margin-left: 30px;">
          <el-checkbox v-model="form.ifRisk" no="ifRisk" :disabled="oujianEditLimit" />
        </el-form-item>
        <!--是否有主单号号段-->
        <el-form-item v-if="form.seaCmp" :label="$t('CargoMsg.Cargo_IfExistMblNumberRange')" label-width="110px" style="margin-left: 30px;">
          <el-checkbox v-model="form.ifExistMblNumberRange" no="ifExistMblNumberRange" />
        </el-form-item>
      </el-form>
    </div>
    <div v-if="form.customer || form.overseaAgent || form.designationAgent " class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item :label="$t('CargoMsg.Cargo_WarehouseCode')" class="margin-Right90">
          <div style="display: flex;">
            <el-input v-model="form.warehouseCode" no="warehouseCode" style="flex-grow: 1" />
            <el-tooltip :content="$t('CargoMsg.Cargo_WarehouseCodeLengthLimit')">
              <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
            </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-form :disabled="readonly" :inline="true" label-width="120px" label-position="left" class="form-item-400">
      <el-form-item :label="' '">
        <div style="display: flex">
          <el-checkbox v-model="form.designatedCargoWarehouseNo" :title="$t('CargoMsg.Cargo_DesignatedCargoWarehouseNo')" no="designatedCargoWarehouseNo" style="margin-right: 5px;" />{{ $t('CargoMsg.Cargo_DesignatedCargoWarehouseNo') }}
          <el-checkbox v-model="form.selfCargoWarehouseNo" :title="$t('CargoMsg.Cargo_SelfCargoWarehouseNo')" no="selfCargoWarehouseNo" style="padding-left:5px;margin-right: 5px;" />{{ $t('CargoMsg.Cargo_SelfCargoWarehouseNo') }}
        </div>
      </el-form-item>
      <!--专项费用付款申请限制：0-限制，1-不限制-->
      <el-form-item :label="' '">
        <div style="display: flex">
          <el-checkbox v-model="form.specialFeePaymentLimit" no="specialFeePaymentLimit" :title="$t('CargoMsg.Cargo_SpecialFeePaymentLimit')" style="padding-left:5px;margin-right: 5px;" />{{ $t('CargoMsg.Cargo_SpecialFeePaymentLimit') }}
        </div>
      </el-form-item>
    </el-form>
    <div v-if="serviceType===PartnerServiceItem.PARTNER_SERVICE_ALL.code" class="inner-row" style="padding-top:10px;padding-bottom:10px">
      <el-form :disabled="readonly" :inline="true" label-width="50px">
        <el-form-item :label="$t('SeaExport.Roles')" :required="true">
          <el-checkbox v-model="form.customer" no="customer" :disabled="!!isNewDelegation&&!!form.linkedBranchId" @change="checkCustomerFunc">{{ $t('Payment.customer') }}</el-checkbox>
          <el-checkbox v-model="form.bookingAgent" no="bookingAgent" :disabled="!!isNewDelegation&&!!form.linkedBranchId" :title="$t('SeaExport.BookingOrExchangeAgent')">{{ $t('SeaExport.BookingOrExchangeAgent') }}</el-checkbox>
          <el-checkbox v-model="form.seaCmpAgent" no="seaCmpAgent">{{ $t('SeaExport.CarrierAgent') }}</el-checkbox>
          <el-checkbox v-model="form.overseaAgent" no="overseaAgent" :disabled="form.designationAgent" :title="$t('Payment.destinationAgent')">{{ $t('Payment.destinationAgent') }}</el-checkbox>
          <el-checkbox
            v-model="form.designationAgent"
            no="designationAgent"
            :disabled="readonly||!$checkPermission(['filter_partner_overseasAgent'])"
            :title="$t('queryJob.nominatedAgent')"
            @change="designationAgentChangeHandler"
          >{{ $t('queryJob.nominatedAgent') }}</el-checkbox>
          <el-checkbox v-model="form.localAgent" no="localAgent">{{ $t('SeaExport.LocalAgent') }}</el-checkbox>
          <el-checkbox v-model="form.settlementAgent" no="settlementAgent" :title="$t('Payment.settlementAgent')" @change="checkSettleAgentFunc">{{ $t('Payment.settlementAgent') }}</el-checkbox>
          <el-checkbox v-if="seaCarrierVisible" v-model="form.seaCmp" no="seaCarrierVisible">{{ $t('SeaExport.ShippingCompany') }}</el-checkbox>
          <el-checkbox v-if="airCarrierVisible" v-model="form.airCmp" no="airCarrierVisible">{{ $t('SeaExport.AirlineCompany') }}</el-checkbox>
          <el-checkbox v-model="form.customsBroker" no="customsBroker">{{ $t('SeaExport.CustomsBroker') }}</el-checkbox>
          <el-checkbox v-model="form.warehouse" no="warehouse">{{ $t('SeaExport.Warehouse') }}</el-checkbox>
          <el-checkbox v-model="form.truckCmp" no="truckCmp">{{ $t('Partners.isTruckCmp') }}</el-checkbox>
          <el-checkbox v-model="form.shipper" no="shipper">{{ $t('Message.Shipper') }}</el-checkbox>
          <el-checkbox v-model="form.consignee" no="consignee">{{ $t('Message.Consignee') }}</el-checkbox>
          <el-checkbox v-model="form.notify" no="notify">{{ $t('Message.Notify') }}</el-checkbox>
          <el-checkbox v-model="form.portAgent" no="portAgent">{{ $t('Partners.portAgent') }}</el-checkbox>
          <el-checkbox v-model="form.forwardingAgent" no="forwardingAgent" :title="$t('Partners.forwardingAgent')">{{ $t('Partners.forwardingAgent') }}</el-checkbox>
          <el-checkbox v-model="form.loadingPlaceCompany" no="loadingPlaceCompany" :title="$t('Partners.loadingPlaceCompany')">{{ $t('Partners.loadingPlaceCompany') }}</el-checkbox>
          <el-checkbox v-model="form.signBillPlaceCompany" no="signBillPlaceCompany" :title="$t('Partners.signBillPlaceCompany')">{{ $t('Partners.signBillPlaceCompany') }}</el-checkbox>
          <el-checkbox v-model="form.dischargePortCompany" no="dischargePortCompany" :title="$t('Partners.dischargePortCompany')">{{ $t('Partners.dischargePortCompany') }}</el-checkbox>
          <el-checkbox v-model="form.destinationPortCompany" no="destinationPortCompany" :title="$t('Partners.destinationPortCompany')">{{ $t('Partners.destinationPortCompany') }}</el-checkbox>
          <!--贸易商-->
          <el-checkbox v-model="form.tradersSign" no="tradersSign">{{ $t('Partners.traders') }}</el-checkbox>
          <el-checkbox v-model="form.factorySign" no="factorySign" :title="$selectByLang($t('Partners.Factory')+'/'+$t('Order.Producer'),$t('Partners.Factory')+'/'+$t('Order.Producer'),$t('Order.Producer'))">
            {{ $selectByLang($t('Partners.Factory')+'/'+$t('Order.Producer'),$t('Partners.Factory')+'/'+$t('Order.Producer'),$t('Order.Producer')) }}
          </el-checkbox>
          <el-checkbox v-model="form.other" no="other">{{ $t('Message.Other') }}</el-checkbox>
          <el-checkbox v-model="form.terminalCompany" no="terminalCompany" :title="$t('Message.TerminalCompany')">{{ $t('Message.TerminalCompany') }}</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="serviceType===PartnerServiceItem.PARTNER_AGENT.code" class="inner-row" style="padding-top:10px;padding-bottom:10px">
      <el-form :disabled="readonly" :inline="true" label-width="105px">
        <el-form-item label=" " :class="clazz.checkNormal">
          <el-checkbox v-model="form.overseaAgent" no="overseaAgent" :disabled="form.designationAgent" :title="$t('Payment.destinationAgent')">{{ $t('Payment.destinationAgent') }}</el-checkbox>
          <el-checkbox
            v-model="form.designationAgent"
            no="designationAgent"
            :disabled="readonly||!$checkPermission(['filter_partner_overseasAgent'])"
            :title="$t('queryJob.nominatedAgent')"
            @change="designationAgentChangeHandler"
          >{{ $t('queryJob.nominatedAgent') }}</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item v-show="differentiateCustomerAndSupplierFees" :label="$t('CargoMsg.Cargo_CategoryOfPartner')+'：'" :class="isZh?'margin-Right90 checkbox-50':'margin-Right90 checkbox-en-50'" :required="true">
          <el-checkbox :disabled="readonly || oujianEditLimit" :value="form.ifCustomer" no="ifCustomer" @change="customerChangeHandler">{{ $t('Partners.isCustomer') }}</el-checkbox>
          <el-checkbox :disabled="readonly || oujianEditLimit" :value="form.ifSupplier" no="ifSupplier" @change="supplierChangeHandler">{{ $t('SeaExport.Supplier') }}</el-checkbox>
        </el-form-item>
        <el-form-item v-show="form.seaCmp" :label="$t('CargoMsg.Cargo_AssociatedPlatformShippingCompany')">
          <cargo-advance-select
            no="associatedPlatformShippingCompany"
            :disabled="readonly"
            :static-options="shipCompanyInfos"
            filterable
            :filter-tag-names="['shipCompanyChineseName', 'shipCompanyEnglishName', 'shipCompanyCode']"
            tag-name="shipCompanyEnglishName"
            tag-value="uuid"
            :default-value="form.shipCompanyUuid||''"
            @parentCallBack="selectShipCompany"
            @clear="clearShipCompany"
          />
        </el-form-item>
        <el-form-item v-show="form.seaCmp" :label="$t('CargoMsg.Cargo_ShipCompanyThirdPartyCode')">
          <el-input v-model="form.externalCode" :disabled="readonly" no="shipCompanyExternalCode" />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item v-if="form.customer" :label="$t('SeaExport.TradeTerms2')">
          <cargo-advance-select
            no="incoTerm"
            :select-type="selectTypeNames.basic_data_IncoTerm"
            filterable
            :multiple="true"
            :default-multiple-value="incoTerms"
            :clearable="false"
            :placeholder="defaultIncoTerm"
            @parentCallBack="p=>{incoTerms=p.value}"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <!--客户编码-->
        <el-form-item :label="$t('Partners.customerCode')" class="margin-Right90">
          <el-input v-model="form.externalKeyCust" no="externalKeyCust" />
        </el-form-item>
        <!--供应商编码-->
        <el-form-item :label="$t('Partners.supplierCode')">
          <el-input v-model="form.externalKeyVend" no="externalKeyVend" />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item :label="$t('Partners.relatedBusinessType')+'：'" :class="isZh?'margin-Right90 checkbox-50':'margin-Right90 checkbox-en-50'" :required="true">
          <el-checkbox v-model="form.seaExport" no="seaExport">{{ $t('constant.systemConstants.SE') }}</el-checkbox>
          <el-checkbox v-model="form.seaImport" no="seaImport">{{ $t('constant.systemConstants.SI') }}</el-checkbox>
          <el-checkbox v-model="form.airExport" no="airExport">{{ $t('constant.systemConstants.AE') }}</el-checkbox>
          <el-checkbox v-model="form.airImport" no="airImport">{{ $t('constant.systemConstants.AI') }}</el-checkbox>
          <el-checkbox v-model="form.railwayExport" no="railwayExport">{{ $t('constant.systemConstants.RB') }}</el-checkbox>
          <el-checkbox v-model="form.integratedJob" no="integratedJob">{{ $t('constant.systemConstants.IE') }}</el-checkbox>
        </el-form-item>
        <el-form-item v-show="!isNewDelegation" :label="$t('Partners.relatedBranch')">
          <cargo-advance-select
            no="linkedBranchId"
            :select-type="selectTypeNames.basic_data_Office"
            filterable
            :callback-params="{key:'linkedBranchId'}"
            callback-method-type="value"
            :headers="[]"
            :fields="['code']"
            tag-name="code"
            :default-value="form.linkedBranchId||''"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <br v-show="!isNewDelegation">
        <el-form-item label="SCAC" class="margin-Right90">
          <cargo-advance-select
            no="scac"
            :disabled="scacDisabled"
            :select-type="selectTypeNames.SCAC_CODES"
            :cache="false"
            filterable
            :callback-params="{key:'scac'}"
            callback-method-type="value"
            :default-value="form.scac"
            :allow-create="true"
            tag-name="scac"
            :show-custom-label-in-option="true"
            :custom-label="scacLabel"
            @parentCallBack="onScacChange"
          />
        </el-form-item>
        <br v-show="form.seaCmp">
        <el-form-item v-if="form.seaCmp" label="EORI">
          <so-no-input v-model="form.eori" no="86" title="EORI " :disabled="readonly" />
        </el-form-item>
        <br v-show="isNewDelegation">
        <el-form-item v-if="isZY" :label="$t('Partners.BookingAgentLevel')">
          <cargo-advance-select
            no="bookingAgentLevel"
            :disabled="false"
            :select-type="selectTypeNames.local_cache_BookingAgentLevel$BOOKING_AGENT_LEVEL"
            filterable
            :default-value="form.bookingAgentLevel || ''"
            @parentCallBack="p => form.bookingAgentLevel = p.value"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--供应商所属部门-->
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item v-if="showSupplierDepartment" :label="$t('Partners.supplierDepartment')">
          <el-select
            v-model="supplierDepartmentUuids"
            no="supplierDepartmentUuids"
            multiple
            filterable
            clearable
            placeholder="请下拉选择"
            style="width: 400px;"
            :popper-class="'supplier-department-select'"
          >
            <el-option
              v-for="item in supplierDepartmentOptions"
              :key="item.uuid"
              :label="isZh ? item.departmentName : item.departmentCode"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <el-form-item :label="$t('Partners.paymentType')+'：'" class="margin-Right90">
          <div style="display: flex">
            <el-checkbox v-model="form.collection" no="collection" :title="$t('Partners.whetherCollection')">{{ $t('Partners.whetherCollection') }}</el-checkbox>
            <el-radio-group v-if="isZhongyouAdvancePaymentOpen" v-model="form.ifAdvancePayment" :disabled="!isAdd" style="padding-top:6px;">
              <el-radio no="underestimation" :label="false">{{ $t('Partners.Underestimation') }}</el-radio>
              <el-radio no="ifAdvancePayment" :label="true">{{ $t('Partners.IfAdvancePayment') }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item v-if="form.truckCmp" :label="$t('Partners.fleetCode')">
          <el-input v-model="form.plateCode" no="plateCode" />
        </el-form-item>
        <br v-show="form.truckCmp">
        <!--平台供应商-->
        <el-form-item :label="$t('Partners.platformSupplier')">
          <el-select v-model="form.platformProvider" no="platformProvider" clearable style="margin-right: 5px;width: 400px;">
            <el-option :label="isZh?$t('Partners.ouJian'):'ouJian'" value="OJ" />
            <el-option v-for="(item,index) in platFormSuppliers" :key="index" :label="isZh?item.chineseName:item.englishName" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="form.defaultAccount" no="defaultAccount">{{ $t('Partners.DefaultSettlementForInsurance') }}</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="!isSalesForSzfs" class="inner-row" style="padding-left: 121px;">
      <el-form :disabled="readonly" :inline="true" label-width="100px" label-position="left">
        <el-form-item label-width="0">
          <div style="display: flex;">
            <el-checkbox v-model="useSettlementAgent" no="useSettlementAgent" :title="$t('Partners.usingSettlementAgent')">{{ $t('Partners.usingSettlementAgent') }}</el-checkbox>
            <cargo-advance-select
              no="settlementAgent"
              :disabled="!useSettlementAgent"
              :select-type="selectTypeNames.static_data_Company"
              :url="url.partner.settlementAgent"
              :method-params="{officeId:currentOfficeId}"
              :cache="false"
              filterable
              :callback-params="{}"
              callback-method-type="value"
              :multiple="true"
              :default-multiple-value="settlementAgents"
              tag-value="uuid"
              :placeholder="defaultPlaceholder"
              :style="{'margin-left': '10px', 'width': isZh?'290px':'250px'}"
              @parentCallBack="item=>settlementAgents=item.value"
            />
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left">
        <el-form-item :label="$t('Partners.ParentCompany')">
          <cargo-advance-select
            no="parentCompany"
            :disabled="form.parentCompany"
            :cache="false"
            filterable
            :show-custom-label-in-option="true"
            :custom-label="parentCompanyLabel"
            :callback-params="{key:'globalAccountUuid'}"
            callback-method-type="value"
            :default-value="form.globalAccountUuid||''"
            :static-options="parentCompanyArray"
            style="width: 400px"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item v-show="form.seaCmp" :label="''" style="padding-left: 80px">
          <div style="display: flex">
            <el-checkbox v-model="form.mscSupplement" no="mscSupplement" :title="$t('CargoMsg.Cargo_ShowTab')" style="width: 105px">{{ $t('CargoMsg.Cargo_ShowTab') }}</el-checkbox>
            <el-select v-show="form.mscSupplement" v-model="form.mscSupplementType" no="mscSupplementType" filterable style="padding-right: 40px">
              <el-option
                v-for="(item,index) in SystemConstants.MSC_SUPPLEMENT_TYPE_LIST"
                :key="index"
                :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-200">
        <el-form-item :label="`${$t('baseInfo.partner.region')}（${$t('baseInfo.partner.area')}）`" style="margin-right: 0">
          <cargo-advance-select
            no="region"
            :select-type="selectTypeNames.basic_data_Country"
            filterable
            :callback-params="{key:'region'}"
            callback-method-type="value"
            :default-value="form.region"
            style="width: 160px"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
      </el-form>
      <el-form :disabled="readonly" :inline="true" label-position="right" class="form-item-200">
        <cargo-area
          no="city"
          :country.sync="form.region"
          :province.sync="form.province"
          :city.sync="form.city"
          :district.sync="form.districts"
          :select-width="165"
          city-label-width="105"
          style="display: inline-block"
        />
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left">
        <el-form-item :label="$t('SeaExport.Addr')" class="form-item-400 margin-Right90" :required="!isXy">
          <el-input v-model="form.address" no="address" :disabled="oujianEditLimit" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ZIP')">
          <el-input v-model="form.zipCode" no="zipCode" style="width: 150px" />
        </el-form-item>
        <el-form-item :label="$t('Partners.supplierPrincipal')" label-width="90px">
          <cargo-user-select
            no="supplierDirector"
            :method-params="{category:'role'}"
            :default-value="form.supplierDirector||''"
            style="width: 150px"
            @change="p=>{form.supplierDirector=p.value||0}"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left">
        <el-form-item :label="$t('SeaExport.Tel')">
          <el-input v-model="form.tel" no="tel" style="width: 160px" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')" label-width="70px" class="margin-Right90">
          <el-input v-model="form.fax" no="fax" style="width: 160px" />
        </el-form-item>
        <el-form-item :label="$t('Partners.website')" class="form-item-400">
          <el-input v-model="form.url" no="url" />
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left">
        <el-form-item :label="$t('Partners.rmbAccount')">
          <el-input v-model="form.rmbAccount" no="rmbAccount" style="width: 160px" />
        </el-form-item>
        <el-form-item :label="$t('Partners.usdAccount')" label-width="70px" class="margin-Right90">
          <el-input v-model="form.usdAccount" no="usdAccount" style="width: 160px" />
        </el-form-item>
        <el-form-item :label="$t('Payment.taxRate')">
          <div style="display: flex;">
            <el-input-number v-model="form.taxRate" no="taxRate" :controls="false" />%
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner-row">
      <el-form :disabled="readonly" :inline="true" label-width="105px" label-position="left" class="form-item-400">
        <!--结算单位地址-->
        <el-form-item :label="$t('CargoMsg.Cargo_AccountAddr')" class="margin-Right90">
          <el-input
            ref="accountAddr"
            v-model="form.accountAddr"
            no="accountAddr"
            type="textarea"
            :rows="3"
            @dblclick.native="showAdvanceTextDialog($t('CargoMsg.Cargo_AccountAddr'),form.accountAddr,val => { form.accountAddr = val } )"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.AdditionalNotes')">
          <el-input v-model="form.remarks" no="remarks" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
    </div>
    <!-- 查看协议弹窗 -->
    <el-dialog
      id="agreement-dialog"
      v-el-drag-dialog
      :visible.sync="agreementDialog.visible"
      :title="$t('Partners.crossTenantEntrustedBookingGeneralProtocol')"
      width="800px"
      :close-on-click-modal="false"
    >
      <div style="text-align:center;font-weight:bold">{{ $t('Partners.crossTenantEntrustedBookingGeneralProtocol') }}</div>
      <pre>
        {{ $t('Partners.agreementContent') }}
      </pre>
      <span slot="footer">
        <el-button no="close" @click="agreementDialog.visible=false">{{ $t('Message.Close') }}</el-button>
      </span>
    </el-dialog>
    <settleAgentDialog
      :visible.sync="settleAgentDialog.visible"
      :c-list="settleAgentDialog.cList"
      :func="settleAgentDialog.func"
      :uuid="settleAgentDialog.uuid"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        style="height: 198px;"
      />
      <span slot="footer">
        <el-button v-show="!readonly" no="finishAdvanceText" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="advanceTextDialogClose" @click="advanceTextDialog.visible = false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 分公司选择弹窗 -->
    <branch-select-dialog :visible.sync="branchSelectDialog.visible" :office-list="branchCompanyHierarchy ? currentOfficeList : null" :value="branchSelectDialog.value" @callback="branchSelectDialog.callback" />
  </div>
</template>

<script>
import soNoInput from '@/components/Cargo/Job/soNoInput'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoArea from '@/components/Cargo/Common/cargoArea'
import settleAgentDialog from '@/views/cargo/v0/Information/components/partner/tab/SettleAgentDialog'
import pinyin from 'js-pinyin'
import lodash from 'lodash'
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { getSimilarPartners, saveSettlementAgentsOfCompany } from '@/api/company'
import * as companyApi from '@/api/company'
import * as financeApi from '@/api/financeManage/financeCodeMapping'
import { getAllTenant } from '@/api/auth'
import StrUtils from '@/utils/StrUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { cacheKeys, getCacheListByKey, getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { cache } from '@/utils/cacheManager'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import { getOfficeListByTenantId } from '@/api/office'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import * as PartnerServiceItem from '@/class/cargo/model/parameters/PartnerServiceItem'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { findMinSpaces } from '@/utils/commonUtil'
import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import BranchSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog'
import { getAllShipCompany } from '@/api/partner/shipping'
import { getSupplierDepartmentList } from '@/api/partner/supplierDepartment'

export default {
  name: 'BasicInfo',
  components: { cargoAdvanceSelect, cargoUserSelect, cargoArea, settleAgentDialog, cargoRichTextarea, CargoOwnedBranchSelect, BranchSelectDialog, soNoInput },
  props: {
    serviceType: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    currentRow: {
      type: Object,
      required: true
    },
    oujianEditLimit: {
      type: Boolean,
      default: false
    },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    const isZh = this.$i18n.locale === 'zh'
    const config = {
      tianYanChaSwtich: 0,
      tianYanChaUrl: ''
    }
    const initialForm = new Company().fillDefaultValue().getData()
    Object.assign(initialForm, {
      uuid: '',
      cmpIdx: 0,
      chineseName: '',
      shortName: '',
      englishName: '',
      cnShortName: '',
      global: false,
      active: false,
      inactiveReason: '',
      branchId: 0,
      relateTenantUuid: '',
      relateTenantId: 0,
      relateTenantOfficeId: 0,
      fba: false,
      customer: false,
      bookingAgent: false,
      seaCmpAgent: false,
      overseaAgent: false,
      designationAgent: false,
      localAgent: false,
      settlementAgent: false,
      seaCmp: false,
      airCmp: false,
      customsBroker: false,
      warehouse: false,
      truckCmp: false,
      shipper: false,
      consignee: false,
      notify: false,
      portAgent: false,
      forwardingAgent: false,
      loadingPlaceCompany: false,
      signBillPlaceCompany: false,
      dischargePortCompany: false,
      destinationPortCompany: false,
      tradersSign: false,
      factorySign: false,
      other: false,
      terminalCompany: false,
      seaExport: true,
      seaImport: true,
      airExport: true,
      airImport: true,
      railwayExport: true,
      integratedJob: true,
      linkedBranchId: 0,
      scac: '',
      collection: false,
      platformProvider: '',
      defaultAccount: false,
      plateCode: '',
      region: 'CN',
      province: '',
      city: '',
      districts: '',
      address: '',
      zipCode: '',
      tel: '',
      fax: '',
      url: '',
      rmbAccount: '',
      usdAccount: '',
      globalAccountUuid: null,
      taxRate: 0.0,
      remarks: '',
      /* 其他默认值字段 */
      mustInputScn: false,
      detailedAddress: '',
      approvedState: 0,
      approvedBy: 0,
      rejectReason: '',
      parentBranchId: 0,
      freightVolume30: 0,
      freightVolume60: 0,
      freightVolume90: 0,
      freightVolumeGt90: 0,
      ifOpenSop: false,
      accountAddr: '',
      parentCompany: false,
      interestFree: false,
      unifiedSign: false,
      ifRisk: false,
      ifCustomer: true,
      ifSupplier: true,
      warehouseCode: '',
      internalCorrespondent: false,
      bookingAgentLevel: '',
      ifExistMblNumberRange: false,
      specialFeePaymentLimit: true
    })
    return {
      isZh,
      config,
      PartnerServiceItem,
      activeEnabled: this.$checkPermission(['button_fmVerify_accept']),
      seaCarrierVisible: this.$checkPermission(['filter_partner_seaCarrier']),
      airCarrierVisible: this.$checkPermission(['filter_partner_airCarrier']),
      clazz: {
        checkNormal: isZh ? 'checkbox-80' : 'checkbox-120',
        checkLarge: isZh ? 'checkbox-100' : 'checkbox-130'
      },
      tenantOfficeList: [],
      partnersApproved: null,
      extendedInterestRate: false, // 是否显示免息公司
      currencyRequirementMustTip: 0,
      selectTypeNames: TYPE_NAMES,
      isNewDelegation: 0,
      tenants: [],
      initialForm,
      SystemConstants,
      form: { ...initialForm },
      useCrossTenant: false,
      useSettlementAgent: false,
      scacDisabled: false,
      scacManualEntry: false,
      settlementAgents: [],
      incoTerms: [],
      globalDisabled: false,
      agreementDialog: {
        visible: false
      },
      roles: [
        'customer', 'bookingAgent', 'seaCmpAgent', 'overseaAgent', 'designationAgent', 'localAgent',
        'settlementAgent', 'seaCmp', 'airCmp', 'customsBroker', 'warehouse', 'truckCmp', 'shipper',
        'consignee', 'notify', 'portAgent', 'forwardingAgent', 'loadingPlaceCompany', 'signBillPlaceCompany',
        'dischargePortCompany', 'destinationPortCompany', 'other', 'terminalCompany', 'tradersSign', 'factorySign'
      ],
      settleAgentDialog: {
        visible: false,
        cList: null,
        func: null,
        uuid: ''
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        }
      },
      parentCompanyArray: [], // 母公司下拉框数据源
      officeChange: false, // 分公司是否发生变更
      refreshId: 0,
      multipleRefreshId: 0,
      platFormSuppliers: InsuranceConstants.INSURANCE_PLATFORM, // 平台供应商
      branchSelectDialog: {
        visible: false,
        value: [],
        callback: () => {}
      },
      showUnifiedSign: false,
      showIfRisk: false,
      yuhaiApiIsEdit: false,
      differentiateCustomerAndSupplierFees: false,
      branchCompanyHierarchy: false,
      isZY: false,
      isXy: false,
      isZhongyouAdvancePaymentOpen: false, // 是否开启中邮预付款功能
      isUpdateCnShortName: false,
      shipCompanyInfos: [],
      supplierDepartmentUuids: [],
      supplierDepartmentOptions: []
    }
  },
  computed: {
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    url() {
      return URL
    },
    readonly() {
      return !this.action || this.action === 'look'
    },
    hbBranchIdVisible() {
      if (this.$store.getters.isGroupCompany) {
        return this.$store.getters.isAdmin || this.$checkPermission(['role_SMPartner_changeBranchID'])
      }
      return false
    },
    showTianYanCha() {
      return this.config.tianYanChaSwtich === 1
    },
    tianYanChaUrl() {
      const name = this.form.chineseName
      if (name) {
        // 天眼查url
        return this.config.tianYanChaUrl + encodeURIComponent(name)
      }
      return ''
    },
    seaAirNum() {
      return (this.seaCarrierVisible ? 1 : 0) + (this.airCarrierVisible ? 1 : 0)
    },
    currentOfficeList() {
      const allOffice = [...getCacheListByKey(TYPE_NAMES.basic_data_Office_All)]
      allOffice.sort((a, b) => a.level - b.level)
      const keySet = new Set()
      for (const office of this.$store.state.user.userInfo.currentUserOfficeList) {
        keySet.add(office.uuid)
      }
      const result = []
      for (const office of allOffice) {
        if (keySet.has(office.uuid)) {
          result.push(office)
        } else if (office.parentBranchUuid && keySet.has(office.parentBranchUuid)) {
          keySet.add(office.uuid)
          result.push(office)
        }
      }
      return result
    },
    defaultPlaceholder() {
      if (this.settlementAgents && this.settlementAgents.length) {
        return ' '
      }
    },
    defaultIncoTerm() {
      if (this.incoTerms && this.incoTerms.length) {
        return ' '
      }
    },
    // 是否新增客户
    isAdd() {
      return StrUtils.isEmpty(this.form.uuid)
    },
    defaultSupplierDepartmentPlaceholder() {
      if (this.supplierDepartmentUuids && this.supplierDepartmentUuids.length) {
        return ' '
      }
    },
    showSupplierDepartment() {
      return this.form.bookingAgent || this.form.seaCmpAgent || this.form.overseaAgent ||
             this.form.designationAgent || this.form.localAgent || this.form.settlementAgent ||
             this.form.seaCmp || this.form.airCmp || this.form.customsBroker || this.form.warehouse ||
             this.form.truckCmp || this.form.shipper || this.form.consignee || this.form.notify ||
             this.form.portAgent || this.form.forwardingAgent || this.form.loadingPlaceCompany ||
             this.form.signBillPlaceCompany || this.form.dischargePortCompany || this.form.destinationPortCompany ||
             this.form.other || this.form.terminalCompany || this.form.tradersSign || this.form.factorySign
    }
  },
  watch: {
    useSettlementAgent(newVal) {
      if (!newVal) {
        this.settlementAgents = []
      }
    },
    'form.seaCmp': {
      handler(value) {
        if (!value) {
          this.form.ifExistMblNumberRange = false
        }
      }
    }
  },
  created() {
    getAllTenant().then(res => {
      this.tenants = res.data
    })
    getAllShipCompany().then(res => {
      this.shipCompanyInfos = res.data
    })
    getSupplierDepartmentList().then(res => {
      this.supplierDepartmentOptions = res.data
    })
    if (this.shipCompanyInfos.length > 0 && this.form.shipCompanyUuid) {
      const shipCompanyInfo = this.shipCompanyInfos.filter(item => item.uuid === this.form.shipCompanyUuid)
      if (!shipCompanyInfo) {
        this.form.shipCompanyUuid = null
      }
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.readConfig()
        if (row.branchId === this.form.branchId) {
          this.refreshId += 1
        }
        if (row.multipleBranchId === this.form.multipleBranchId) {
          this.multipleRefreshId += 1
        }
        this.form = row
        if (!this.form.uuid) {
          this.form.active = (this.partnersApproved !== 1 && this.partnersApproved !== 3 && this.partnersApproved !== 4)
        }
        const loading = getLoading4Cxt(this)
        try {
          await this.initCommonData()
        } finally {
          loading.close()
        }
        this.checkActive()
        this.tenantIdChangeHandler()
      } else {
        this.setParentCompany()
      }
    },
    readConfig() {
      this.config.tianYanChaSwtich = Number(cache.config.get('tianYanChaSwtich'))
      this.config.tianYanChaUrl = cache.config.get('tianYanChaUrl')
      this.partnersApproved = Number(cache.config.get('PartnersApproved'))
      this.extendedInterestRate = (Number(cache.config.get('ExtendedInterestRate')) !== 0)
      this.currencyRequirementMustTip = Number(cache.config.get('PartnerInvoiceCurrencyRequirementSelected'))
      this.showUnifiedSign = String(cache.config.get('ToExoSystem')) === 'zy' && Office.hasHq()
      this.yuhaiApiIsEdit = (Number(cache.config.get('yuhaiApiIsEdit')) === 1) // 越海接口是否可编辑
      this.differentiateCustomerAndSupplierFees = Number(cache.config.get('differentiateCustomerAndSupplierFees')) === 1
      this.branchCompanyHierarchy = Number(cache.config.get('BranchCompanyHierarchy')) === 1
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
      this.isXy = String(cache.config.get('ToExoSystem')) === 'XYCW' // 显示中邮选项
      this.isZhongyouAdvancePaymentOpen = Number(cache.config.get('isZhongyouAdvancePaymentOpen')) === 1
      this.showIfRisk = (Number(cache.config.get('oujianPartner')) === 1) // CARGO-45565【欧坚客户化】数据库抓起限制“合作伙伴”
    },
    async initCommonData() {
      this.isNewDelegation = Number(cache.config.get('isNewDelegation'))
      if (this.isNewDelegation && this.form.linkedBranchId) {
        const officeList = getCacheListByKey(TYPE_NAMES.basic_data_Office)
        const branchList = officeList.filter(p => p.officeId === this.form.linkedBranchId)
        if (branchList.length > 0) {
          this.form.linkedBranchCode = branchList[0].code
        } else {
          const office = await Office.getOfficeById(this.form.linkedBranchId)
          this.form.linkedBranchCode = office ? office.code : ''
        }
      }
      this.useCrossTenant = false
      this.scacDisabled = false
      this.globalDisabled = false
      let useSettlementAgent = false
      let settlementAgents = []
      if (this.form.uuid) {
        this.useCrossTenant = !!this.form.relateTenantId
        this.scacDisabled = !!this.form.scac
        await companyApi.getSettlementAgentsByCompany(this.form.uuid).then(res => {
          settlementAgents = res.data
          useSettlementAgent = settlementAgents.length > 0
        })
        // 外键如果为空字符串，则置为null（避免更新报错）
        if (this.form.globalAccountUuid === '') {
          this.form.globalAccountUuid = null
        } else {
          this.globalDisabled = !!this.form.globalAccountUuid
        }
      }
      this.useSettlementAgent = useSettlementAgent
      this.settlementAgents = settlementAgents
      this.incoTerms = this.form && this.form.incoTerm ? this.form.incoTerm.split(',') : []
      this.originSettlementAgents = lodash.cloneDeep(settlementAgents)
      this.supplierDepartmentUuids = this.form && this.form.supplierDepartmentUuids ? this.form.supplierDepartmentUuids : []
      await this.setParentCompany()
    },
    getNewForm() {
      const form = { ...this.initialForm }
      form.branchId = this.currentOfficeId
      return form
    },
    async selectCargoItem(item) {
      if (item.key === 'branchId') {
        const newValue = item.value
        const oldValue = this.form.branchId
        if (newValue && oldValue && newValue !== oldValue && this.form.parentCompany &&
          this.form.subsidiaryCompanyList && this.form.subsidiaryCompanyList.length > 0) {
          await this.$confirm(this.$t('Partners.officeChangeForSubsidiaryCompany'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('constant.yes'),
            cancelButtonText: this.$t('constant.no'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(async() => {
            this.form.branchId = newValue
            await this.setParentCompany()
            const index = this.parentCompanyArray.findIndex(p => p.uuid === this.form.uuid)
            if (index < 0) {
              this.form.globalAccountUuid = ''
            }
          }).catch(() => {
            this.form.branchId = oldValue
          })
        } else {
          this.form.branchId = newValue
          await this.setParentCompany()
          const index = this.parentCompanyArray.findIndex(p => p.uuid === this.form.uuid)
          if (index < 0) {
            this.form.globalAccountUuid = ''
          }
        }
      } else {
        this.form[item.key] = item.value
      }
    },
    onCrossTenantChange() {
      if (!this.useCrossTenant) {
        this.form.relateTenantId = 0
        this.form.relateTenantOfficeId = 0
      }
    },
    onScacChange(item) {
      this.form[item.key] = item.value
      this.$nextTick(() => {
        this.scacManualEntry = item.isManualEntry
      })
    },
    onActiveChange(val) {
      // 有停用原因时，不允许勾选“激活”，提示先清空停用原因
      if (val && this.form.inactiveReason) {
        this.$nextTick(() => {
          this.form.active = false
        })
        this.$message.warning(this.$t('Partners.clearInactiveReasonFirst'))
      }
    },
    async getSubmitData() {
      const form = this.form
      if (form.address) {
        form.address = form.address.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
      }
      // 对于不需要审核的Tenant，新增时直接过
      if (!form.uuid) {
        form.approvedState = (this.partnersApproved !== 1 && this.partnersApproved !== 3 && this.partnersApproved !== 4) ? 1 : 0
        if (form.approvedState === 1) {
          form.approvedBy = this.$store.getters.userId
          form.dateApproved = DateUtils.formatStandardDateTime(new Date())
        }
      }
      if (!form.cnShortName) {
        form.cnShortName = this.buildCnShortName(form.chineseName)
      }
      form.incoTerm = this.incoTerms && this.incoTerms.length > 0 ? this.incoTerms.join(',') : ''
      form.supplierDepartmentUuids = this.supplierDepartmentUuids
      // 设置supplierFlag：勾选了除客户外的任何角色则为true
      const nonCustomerRoles = this.roles.filter(r => r !== 'customer')
      form.supplierFlag = nonCustomerRoles.some(role => form[role])
      await this.validateForm(form)
      const submitData = {
        company: form
      }
      // 若分公司切换，则修改客户页签下归属部门
      if (this.form.branchIdChange && this.form.customerDetail) {
        submitData.customerDetail = this.form.customerDetail
      }
      return submitData
    },
    async validateForm(form) {
      if (StrUtils.isEmpty(form.chineseName)) {
        throw new TabError(this.$t('CargoMsg.Cargo_ChineseNameCanTBeEmpty'), 'basicInfo')
      }
      if (StrUtils.isEmpty(form.englishName)) {
        throw new TabError(this.$t('CargoMsg.Cargo_EnglishNameCanTBeEmpty'), 'basicInfo')
      }
      if (StrUtils.isEmpty(form.shortName)) {
        throw new TabError(this.$t('Partners.shortNameCannotBeEmpty'), 'basicInfo')
      }
      // CARGO-8226，铁路出口业务类型
      if (!(form.customer || form.bookingAgent || form.overseaAgent ||
        form.designationAgent || form.localAgent || form.seaCmp ||
        form.airCmp || form.customsBroker || form.warehouse ||
        form.settlementAgent || form.truckCmp || form.shipper ||
        form.consignee || form.notify || form.mustInputScn || form.other || form.terminalCompany || form.seaCmpAgent ||
        form.portAgent || form.forwardingAgent || form.loadingPlaceCompany || form.signBillPlaceCompany || form.dischargePortCompany || form.destinationPortCompany || form.tradersSign || form.factorySign)) {
        throw new TabError(this.$t('Partners.partnerRoleMustBeSelected'), 'basicInfo')
      }
      if (!(form.seaExport || form.seaImport || form.airExport || form.airImport || form.railwayExport || form.integratedJob)) {
        throw new TabError(this.$t('Partners.oneBusinessTypeForCustomer'), 'basicInfo')
      }
      if (form.customer && StrUtils.isEmpty(form.address) && !this.isXy) {
        throw new TabError(this.$t('Partners.customerAddressNotEmpty'), 'basicInfo')
      }
      let roleChecked = false
      for (const name of this.roles) {
        if (form[name]) {
          roleChecked = true
          break
        }
      }
      if (!roleChecked) {
        throw new TabError(this.$t('Partners.partnerRoleMustBeSelected'), 'basicInfo')
      }
      if (!form.seaExport && !form.seaImport && !form.airExport && !form.airImport && !form.railwayExport && !form.integratedJob) {
        throw new TabError(this.$t('Partners.customerBusinessTypeMustBeSelected'), 'basicInfo')
      }
      if (form.customer) {
        const hasContact = this.form.contacts && this.form.contacts.length > 0
        if (!hasContact && !this.isXy) {
          throw new TabError(this.$t('CargoMsg.Cargo_ContactPersonToFillInA'), 'contactForm')
        }
        if (Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1 && this.form.customerDetail && !this.form.customerDetail.designated && !this.form.customerDetail.seftCanvass) {
          throw new TabError(this.$t('CargoMsg.Cargo_PleaseSelectSolicitationType'), 'customerForm')
        }
      }
      if (form.customerDetail && this.form.customerDetail.currencyRequirements <= 0 && this.currencyRequirementMustTip) {
        throw new TabError(this.$t('CargoMsg.Cargo_PleaseInvoicingRequirementsTab'), 'titleForm')
      }
      if (form.uuid) {
        form.companyKey = form.uuid
      }
      const data = {}
      for (const key in this.form) {
        if (typeof this.form[key] === 'object') {
          continue
        }
        data[key] = this.form[key]
      }
      if (form.externalKeyCust || form.externalKeyVend) {
        const regex = /[\u4e00-\u9fa5]/
        if (regex.test(form.externalKeyCust)) {
          throw new TabError(this.$t('Partners.customerCodeNotSupportChinese'), 'basicInfo')
        }
        if (regex.test(form.externalKeyVend)) {
          throw new TabError(this.$t('Partners.supplierCodeNotSupportChinese'), 'basicInfo')
        }
      }
      if (form.warehouseCode && form.warehouseCode.length > 10) {
        throw new TabError(this.$t('CargoMsg.Cargo_WarehouseCodeLengthLimit'), 'basicInfo')
      }
      if (this.isZY && form.bookingAgent && !form.bookingAgentLevel) {
        throw new TabError(this.$t('Partners.bookingAgentLevelNotSelected'), 'basicInfo')
      }
    },
    checkChineseName() {
      let convertChineseName = ''
      if (this.form.chineseName) {
        this.form.chineseName = this.form.chineseName.trim()
        // CARGO-33794 【合作伙伴】模块，中英文名全角与半角括号做限制
        // 中文名半角括号自动转为全角括号
        convertChineseName = this.form.chineseName.replace(/\(/g, '（')
        convertChineseName = convertChineseName.replace(/\)/g, '）')
      }
      if (convertChineseName) {
        if (this.checkRepeatField('chineseName', convertChineseName, this.form.uuid)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ChineseNameAlreadyExists'))
          return
        }
        const data = {}
        data.chineseName = convertChineseName
        this.checkSimilarPartners(data, 'chineseName')
      }
    },
    checkCnShortName() {
      this.isUpdateCnShortName = true
    },
    checkEnglishName() {
      let convertEnglishName = ''
      if (this.form.englishName) {
        // 英文名全角括号自动转为半角括号
        convertEnglishName = StrUtils.toHalfword(this.form.englishName.trim())
      }
      if (convertEnglishName) {
        if (this.checkRepeatField('englishName', convertEnglishName, this.form.uuid)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_EnglishNameAlreadyExists'))
          return
        }
        const data = {}
        data.englishName = convertEnglishName
        this.checkSimilarPartners(data, 'englishName')
      }
    },
    checkRepeatField(fieldName, fieldValue, uuid) {
      if (!fieldValue) {
        return false
      }
      const companyList = getCacheListByKey(TYPE_NAMES.basic_data_Company)
      if (companyList.length === 0) {
        return false
      }
      const index = companyList.findIndex(p => p.branchId === this.form.branchId && this.changeNameBracket(p[fieldName], fieldName) === fieldValue && (!uuid || uuid !== p.uuid))
      return index >= 0
    },
    checkSimilarPartners(data, fieldName) {
      if (!data) {
        return
      }
      if (fieldName === 'englishName' && (!data.englishName || data.englishName.length === 0)) {
        return
      }
      if (fieldName === 'chineseName' && (!data.chineseName || data.chineseName.length === 0)) {
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        data.currentBranchId = this.form.branchId
        // 获取相似合作伙伴列表
        getSimilarPartners(data).then(res => {
          const partnerList = res.data
          if (partnerList) {
            let filteredData = []
            if (fieldName === 'englishName') {
              filteredData = partnerList.filter(item => item.uuid !== this.form.uuid).map(item => item.englishName)
            }
            if (fieldName === 'chineseName') {
              filteredData = partnerList.filter(item => item.uuid !== this.form.uuid).map(item => item.chineseName)
            }
            const result = filteredData.reduce((shortest, current) => {
              return shortest.length <= current.length ? shortest : current
            }, Infinity)
            if (filteredData.length > 0) {
              this.$message.warning(this.$t('CargoMsg.Cargo_SimilarPartners', [result, filteredData.length]))
            }
          }
        })
      } finally {
        loading.close()
      }
    },
    changeNameBracket(name, fieldName) {
      let result = ''
      if (fieldName === 'englishName') {
        result = StrUtils.toHalfword(name)
      }
      if (fieldName === 'chineseName') {
        result = name.replace(/\(/g, '（')
        result = result.replace(/\)/g, '）')
      }
      return result
    },
    async executeTask(result) {
      // 更新结算代理
      if (this.settlementAgents && result.uuid) {
        const params = {}
        params.settlementAgentList = this.settlementAgents
        params.companyUuid = result.uuid
        await saveSettlementAgentsOfCompany(params)
      }
      // CARGO-1161，修改合作伙伴代码是否自动更新编码映射中的客商编码
      if (Number(cache.config.get('updateFinanceCodeByPartnerCode')) === 1) {
        const params = {}
        params.cmpIdx = result.cmpIdx
        params.cnShortName = result.cnShortName
        params.branchId = this.$store.getters.currentOfficeId
        await financeApi.updateFinanceCodeByPartnerCode(params)
      }
    },
    buildCnShortName(chineseName) {
      const matches = chineseName.match(/[\u4e00-\u9fa5]/g)
      if (matches) {
        let str = ''
        for (let i = 0; i < matches.length && i < 8; ++i) {
          str += matches[i]
        }
        return pinyin.getCamelChars(str)
      } else {
        return chineseName.substr(0, 8)
      }
    },
    tenantIdChangeHandler(item) {
      let tenantId = ''
      if (item) {
        tenantId = item.value
        this.form.relateTenantId = tenantId || 0
        if (tenantId !== '1') {
          this.form.relateTenantOfficeId = tenantId ? 1 : 0
        }
      } else {
        tenantId = String(this.form.relateTenantId || '')
      }
      if (!tenantId) return
      const list = LocalStorageUtils.getConfiguration(tenantId)
      if (list) {
        this.tenantOfficeList = list
      } else {
        getOfficeListByTenantId({ tenantId }).then(resp => {
          this.tenantOfficeList = resp.data
          LocalStorageUtils.setConfiguration(tenantId, resp.data)
        })
      }
      if (this.tenantOfficeList && tenantId !== '1') {
        for (const obj of this.tenantOfficeList) {
          if (this.form.relateTenantOfficeId === obj.officeId) {
            this.form.relateTenantOfficeId = obj.officeId
          }
        }
      }
    },
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    scacLabel(data) {
      if (data) {
        if (data.chineseName !== undefined && data.englishName !== undefined && !(this.scacManualEntry && data.scac === this.form.scac)) {
          return '[' + data.chineseName + ']' + data.englishName
        } else {
          return data.scac
        }
      }
      return ''
    },
    checkSettleAgentFunc(value) {
      this.form.cancelSettleAgent = !value
    },
    checkCustomerFunc(value) {
      if (!value) {
        this.incoTerms = []
      }
    },
    checkActive() {
      if (this.partnersApproved > 0) {
        if (!this.form.uuid || this.form.approvedState === 0 || this.form.approvedState === 2) {
          this.activeEnabled = false
        } else {
          this.activeEnabled = !this.readonly
        }
      } else {
        this.activeEnabled = !this.readonly
        if (this.partnersApproved === 0 && !this.form.uuid) {
          this.activeEnabled = false
        }
      }
    },
    designationAgentChangeHandler(param) {
      this.form.overseaAgent = this.form.designationAgent || this.form.overseaAgent
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    async setParentCompany() {
      this.parentCompanyArray = []
      let companyList = await getSpecificBasicData(cacheKeys.basic_data_Company)
      if (companyList && companyList.length > 0) {
        if (this.form.branchId === 1) {
          companyList = companyList.filter(p => p.branchId === 1 && p.parentCompany)
        } else {
          companyList = companyList.filter(p => (p.branchId === 1 || p.branchId === this.form.branchId) && p.parentCompany)
        }
      }
      if (this.form.uuid) {
        const index = companyList.findIndex(p => p.uuid === this.form.uuid)
        if (this.form.parentCompany) {
          if (index < 0) {
            companyList.push(this.form)
          }
        } else {
          if (index > -1) {
            companyList.slice(index, 1)
          }
        }
      }
      this.parentCompanyArray = companyList
    },
    parentCompanyLabel(data) {
      if (data) {
        if (data.branchId > 0) {
          if (data.branchId === 1) {
            return '[HQ]' + data.chineseName
          } else {
            const office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', data.branchId)
            if (office) {
              return '[' + office.code + ']' + data.chineseName
            }
          }
        }
      }
      return ''
    },
    async parentCompanyChange() {
      if (!this.form.parentCompany && this.form.subsidiaryCompanyList && this.form.subsidiaryCompanyList.length > 0) {
        this.form.parentCompany = true
        this.$message.warning(this.$t('Partners.changeParentCompany'))
        return
      }
      if (this.form.uuid) {
        if (this.form.parentCompany) {
          this.parentCompanyArray.push(this.form)
          this.form.globalAccountUuid = this.form.uuid
        } else {
          this.form.globalAccountUuid = null
          const index = this.parentCompanyArray.findIndex(p => p.uuid === this.form.uuid)
          if (index > 0) {
            this.parentCompanyArray.slice(index, 1)
          }
        }
      }
    },
    async changeCustomerDept() {
      if (this.form.customerDetail) {
        this.form.branchIdChange = true
        this.form.customerDetail.ownerDepartment = 0
        let data = {}
        data.chineseName = this.form.chineseName
        this.checkSimilarPartners(data, 'chineseName')
        data = {}
        data.englishName = this.form.englishName
        this.checkSimilarPartners(data, 'englishName')
      }
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(arr) {
      if (arr && arr.length > 0) {
        return arr.join(',')
      }
      return ''
    },
    showBranchSelectDialog() {
      this.branchSelectDialog.value = this.toNumArray(this.form.multipleBranchId)
      this.branchSelectDialog.callback = val => {
        this.form.multipleBranchId = this.toTxt(val)
      }
      this.branchSelectDialog.visible = true
    },
    customerChangeHandler(val) {
      if (!(this.form.ifSupplier || val)) {
        this.$message.warning(this.$t('Partners.customersAndSuppliersMustChooseOne'))
        return
      }
      this.form.ifCustomer = val
    },
    supplierChangeHandler(val) {
      if (!(this.form.ifCustomer || val)) {
        this.$message.warning(this.$t('Partners.customersAndSuppliersMustChooseOne'))
        return
      }
      this.form.ifSupplier = val
    },
    // 选择船公司
    selectShipCompany(item) {
      if (item.uuid) {
        this.form.shipCompanyUuid = item.uuid
        if (!this.form.shortName) {
          this.form.shortName = item.shipCompanyCode
        }
        if (!this.form.englishName) {
          this.form.englishName = item.shipCompanyEnglishName
        }
        if (!this.form.chineseName) {
          this.form.chineseName = item.shipCompanyChineseName
        }
        if (!this.form.externalCode && item.externalCode) {
          this.form.externalCode = item.externalCode
        }
        if (!this.form.scac) {
          if (item.amsScacCode) {
            this.form.scac = item.amsScacCode
          } else if (item.emanifestScacCode) {
            this.form.scac = item.emanifestScacCode
          } else if (item.afrScacCode) {
            this.form.scac = item.afrScacCode
          }
        }
      }
    },
    clearShipCompany() {
      this.form.shipCompanyUuid = ''
      this.form.externalCode = ''
    }
  }
}
</script>

<style scoped lang="scss">
.inner-row {
  display: flex;
  padding: 0 16px 0 16px;
  span {
    color: #666666;
  }
  .margin-Right90 {
    margin-right: 90px;
  }
  .checkbox-50 ::v-deep {
    .el-checkbox {
      width: 50px;
    }
  }
  .checkbox-en-50 ::v-deep {
    .el-checkbox {
      width: 50px;
      margin-right: 80px;
    }
  }
  .checkbox-80 ::v-deep {
    .el-checkbox {
      width: 120px;
    }
  }
  .checkbox-100::v-deep.el-checkbox {
    width: 130px;
  }
  .checkbox-120 ::v-deep {
    .el-checkbox {
      width: 120px;
    }
  }
  .checkbox-130::v-deep.el-checkbox {
    width: 130px;
  }
  .form-item-200 ::v-deep {
    .el-form-item__content {
      width: 165px;
    }
  }
  .form-item-400 ::v-deep {
    .el-form-item__content {
      width: 400px;
      .el-radio {
        margin-top: 2px;
        .el-radio__label {
          font-size: 12px !important;
          padding-left: 2px;
        }
      }
      .el-checkbox {
        .el-checkbox__label {
          font-size: 12px !important;
        }
      }
    }
  }
  .cargo-area{
    /deep/ .el-form-item{
      .el-form-item__label{
        text-align: left;
      }
      .el-form-item__content{
        .cargo-advance-select-wrapper{
          width: 160px !important;
        }
      }
      &:nth-of-type(1){
        .el-form-item__label{
          width: 75px;
        }
      }
      &:nth-of-type(2){
        margin-left: 75px;
        .el-form-item__label{
          width: 100px;
        }
      }
      &:nth-of-type(3){
        .el-form-item__label{
          width: 65px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
#agreement-dialog {
  .el-dialog__body {
    height: 400px;
    overflow-y: auto;
    pre {
      white-space: break-spaces;
    }
  }
}
.basicInfoForm .el-checkbox__label{
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: -6px;
}
</style>
